// @flow
import * as React from 'react';

import type { Query } from '~schema';

export default React.createContext<?Query>(undefined);
